import { isEqual, isArray } from 'lodash';

export const descWithCodigoInterno = object => (object.codigoInterno ? `${object.codigoInterno} - ${object.descricao}` : object.descricao);

export const deepNotEquals = (obj1, obj2, key) => {
  // Caso geral sem chave específica
  if (!key) return !isEqual(obj1, obj2);

  // Obter os valores para comparação
  const val1 = obj1[key];
  const val2 = obj2[key];

  // Comparação rápida para referências iguais
  if (val1 === val2) return false;

  // Tratamento especial para arrays
  if (isArray(val1) && isArray(val2)) {
    // Comparação entre cada item do array
    return (
      val1.length !== val2.length || val1.some((item, index) => !isEqual(item, val2[index]))
    );
  }

  // Comparação padrão para outros tipos
  return !isEqual(val1, val2);
};

export default {
  descWithCodigoInterno,
};
